// extracted by mini-css-extract-plugin
export default {"image":"lsf-image","image-progress":"lsf-image-progress","image-progress__bar":"lsf-image-progress__bar"};